var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('RecycleScroller',{staticClass:"nodes",attrs:{"items":_vm.visiblePaths,"item-size":24,"key-field":"path"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('div',{style:({
      "padding-left": (item.path.split("/").length * 16 - 48)+ "px",
      "padding-top": "4px"
    })},[(item)?_c('router-link',{attrs:{"to":("/" + (item.path))}},[_vm._v(_vm._s(item.name))]):_vm._e()],1)]}}])}),_c('div',{staticClass:"content"},[_c('ContentNode',{attrs:{"path":((this.region) + "/" + (this.version) + "/" + (this.nodePath))}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }